
import React, { useEffect, useState, useRef, useMemo } from "react";
import { getBgColor, getPriceChangeBGColor, getPercentile, mergeFilters, transformFilters } from "../../utils/utils";
import Tooltip from "@mui/material/Tooltip";

import { 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { CheckCircle2, ChevronRight, XCircle } from "lucide-react/dist/cjs/lucide-react";
import { apiSlice } from "../../redux/slices/apiSlice";
import { FiExternalLink } from "react-icons/fi";
import { pricing, setIsPreFiltered, setPreDefinedFilter } from "../../redux/slices/pricingSlice";
import { useNavigate } from "react-router-dom";
import amplitude from "../../utils/ampli";
import { selectMIShapeCaratState, setSelectedCaratRange, setSelectedCell, setSelectedMetric, setSelectedNeedsMetric, setSelectedShape } from "../../redux/slices/miShapeCaratSlice";
import MIColorClarityGrid from "./MIColorClarityGrid";

const MIShapeCaratGrid = ({
  accountDetails,
  isCsr,
  caratRanges,
  shapes,
  gridData,
  data,
  defaultTurn,
  weeks,
  isResetting,
}) => {

  const {
    selectedShape,
    selectedCaratRange,
    selectedCell,
    selectedMetric,
    selectedNeedsMetric,
    selectedLocation
  } = useSelector((state) => state.marketIntelligenceShapeCarat);

  
  const [hoveredGroup, setHoveredGroup] = useState([null, null]); // Hovered group state
  const [idealTurn, setIdealTurn] = useState(defaultTurn);
  const drilldownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [queryParams, setQueryParams] = useState({
  //   id: accountDetails.account_id,
  //   shape: selectedCell?.shape,
  //   carat_range: selectedCell?.caratRange,
  //   location: selectedLocation,
  //   duration_in_weeks: selectedNeedsMetric
  // });

  const queryParams = useMemo(() => ({
  id: accountDetails.account_id,
  shape: selectedCell?.shape,
  carat_range: selectedCell?.caratRange,   // ✅ snake-case only
  enumlocation: selectedLocation,
  duration_in_weeks: selectedNeedsMetric,
}), [accountDetails.account_id, selectedCell, selectedLocation, selectedNeedsMetric]);



 // Date Picker sensitivity


  const [shapeCaratFilter, setShapeCaratFilter] = useState({
    discrete: {
      "diamond#shape": [selectedCell?.shape],
      "gem#carats": [
      {
        "from": selectedCell?.caratRange.split('-')[0],
        "to": selectedCell?.caratRange.split('-')[1]
      }
    ]
    }})


const getCellStyle = (bgColor, shape, range) => {
  const isSelected = selectedCell?.shape === shape && selectedCell?.caratRange === range;
  return {
    backgroundColor: bgColor,
    color: "#000",
    border: isSelected ? "2px solid #000" : "1px solid #ccc",
  };
};


  


useEffect(() => {
  // Create a function to update query params
  const updateQueryParams = (updates) => {
      };

  // If a cell is selected, update shape and carat_range
  if (selectedCell) {
    updateQueryParams({
      shape: selectedCell.shape || selectedShape,
      carat_range: selectedCell.caratRange || selectedCaratRange,
    });
  }
}, [selectedCell]);

  const handleMetricChange = (metric) => {
    dispatch(setSelectedMetric(metric));
    const buttonClickedEvent = {
      event_type: `v3_metric_change`,
      value: metric,
    };
  amplitude.track(buttonClickedEvent);
  };

  const handleMonthsMetricChange = (metric) => {
    dispatch(setSelectedNeedsMetric(metric));
    const buttonClickedEvent = {
      event_type: `v3_months_change`,
      value: metric,
    };
  amplitude.track(buttonClickedEvent);
  };

  const metricOptions = {
    sales_distribution: "Sales Distribution",
    price_change: "Price Change",
    overhang: "Inventory Overhang",
    // liquidity: "Liquidity",
  };

  const dateOptions = {
    "12": "3 Months",
    "4": "1 Months",
    "1": "1 Week",
  };
  


    const handleCellClick = (shapeIndex, caratIndex) => {
        const shape = shapes[shapeIndex];
        const caratRange = caratRanges[caratIndex];
        
          // setQueryParams(prev => ({ ...prev, shape, carat_range: caratRange }));
          dispatch(setSelectedShape(shape));
          dispatch(setSelectedCaratRange(caratRange));
          dispatch(setSelectedCell({ shape, caratRange }));
          const buttonClickedEvent = {
            event_type: `v3_shape_carat_cell_click`,
            value: { shape, caratRange },
          };
          amplitude.track(buttonClickedEvent);
          setShapeCaratFilter({
            discrete: {
              "diamond#shape": [shape],
              "gem#carats": [
                {
                  from: caratRange.split('-')[0],
                  to: caratRange.split('-')[1],
                }],
            },
          });

          // Smooth scroll to drilldown component after a brief delay
          setTimeout(() => {
            drilldownRef.current?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 100);
        };
        function roundIfFloat(value) {
              // Check if the value is a number and if it has a decimal part
              if (typeof value === 'number' && value % 1 !== 0) {
                // Round the number to 2 decimal places
                return Math.round(value * 100) / 100;
              }
              // Return the value as it is if it's not a float
              return value;
        }

  // write a function to return number with one decimal place for any given number or integer


        const handleShapeChange = (newShape) => {
          dispatch(setSelectedShape(newShape));
          const shapeIndex = shapes.indexOf(newShape);
          const caratIndex = caratRanges.indexOf(selectedCaratRange);
        
          if (shapeIndex !== -1 && caratIndex !== -1) {

            dispatch(setSelectedCell({
              shape: newShape,
              caratRange: selectedCaratRange,
            }));
          }
          
          // Update shapeCaratFilter with the new shape
          setShapeCaratFilter((prevFilter) => ({
            ...prevFilter,
            discrete: {
              ...prevFilter.discrete,
              "diamond#shape": [newShape],
            },
          }));
          const buttonClickedEvent = {
            event_type: `v3_shape_change_dropdown`,
            value: [newShape],
          };
          amplitude.track(buttonClickedEvent);
        };
        
      const handleCaratChange = (newCaratRange) => {
        dispatch(setSelectedCaratRange(newCaratRange));
      
        // setQueryParams((prevParams) => ({
        //   ...prevParams,
        //   caratRange: newCaratRange,
        // }));
      
        dispatch(setSelectedCell({
          shape: selectedShape,
          caratRange: newCaratRange,
        }))
      
        // Update shapeCaratFilter with the new carat range
        setShapeCaratFilter((prevFilter) => ({
          ...prevFilter,
          discrete: {
            ...prevFilter.discrete,
            "gem#carats": [
              {
                from: newCaratRange.split('-')[0],
                to: newCaratRange.split('-')[1],
              },
            ],
          },
        }));
          const buttonClickedEvent = {
            event_type: `v3_carat_change_dropdown`,
            value: [newCaratRange],
          };
          amplitude.track(buttonClickedEvent);
      };


  const handleSearchClick = (value) => {
    if (value.discrete["diamond#shape"]?.includes("0007cushion_brilliant")) {
      value.discrete["diamond#shape"].push("0008cushion_modified");
    }
        const discreteFilters = transformFilters(value);
        const buttonClickedEvent = {
          event_type: `v3_stock_performance_to_PCP_shape_carat`,
          value: discreteFilters,
        };
        amplitude.track(buttonClickedEvent);
        
        dispatch(setIsPreFiltered(true));
        dispatch(setPreDefinedFilter(discreteFilters));
        navigate(`/price_co-pilot?page=0`);
      }; 


  const handleShapeClick = (value) => {
    const newShapeState = {
      discrete: {
          "diamond#shape":value == "0007cushion_brilliant"?[value, "0008cushion_modified"]: [value],
      },
    };

    const discreteFilters = transformFilters(newShapeState); // Use the updated state  
      dispatch(setIsPreFiltered(true));
      dispatch(setPreDefinedFilter(discreteFilters));
      const buttonClickedEvent = {
        event_type: `v3_shape_header_click_to_pcp`,
        value: discreteFilters,
      };
      amplitude.track(buttonClickedEvent);
      navigate(`/price_co-pilot?page=0`);
    }; 

  const handleCaratClick = (value) => {
    const newCaratState = {
      discrete: {
        "gem#carats": [
          {
            from: value.split('-')[0],
            to: value.split('-')[1],
          },
        ],
      },
    };

      const discreteFilters = transformFilters(newCaratState); // Use the updated state  
      dispatch(setIsPreFiltered(true));
      dispatch(setPreDefinedFilter(discreteFilters));
      const buttonClickedEvent = {
        event_type: `v3_carat_row_click_to_pcp`,
        value: discreteFilters,
      };
     amplitude.track(buttonClickedEvent);
      navigate(`/price_co-pilot?page=0`);
    }; 



    const formatTooltipPrice = (value) => {
      if (value == null || isNaN(value)) {
        return "0"; // Handle null, undefined, or NaN values
      }
      if (value >= 1_000_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      }
      return `$${value.toFixed(0)}`;
    };

    const formatPrice = (value) => {
      if (value >= 1_000_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      }
      return `<$1K`; // Default format for smaller values
    };

  return (
    <div className="shape-carat-grid">
      {/* Shape-Carat Grid */}
    <div className="grid-shape-size-container w-max flex-col items-center mx-auto justify-center ">
      <div className="controls flex justify-between w-full items-center mb-3 pt-3">
            <FormControl size="small">
              {/* <FormLabel id="metric-row-radio-buttons-group-label inline">Metric</FormLabel> */}
              <div className="flex justify-between  gap-3 items-center" style={{ minWidth: 450}}>
              <InputLabel>Metric</InputLabel>
              <Select
                value={selectedMetric}
                style={{ minWidth: 118 }}
                label="Metric"
              >
                {Object.entries(metricOptions).map(([value, label]) => (
                <MenuItem key={value} value={value} onClick={() => handleMetricChange(value)}>
                  {label}
                </MenuItem>
                ))}
              </Select>
            </div>
        </FormControl>
        
     
        <FormControl size="small" disabled={selectedMetric == "price_change" ? false : true}>
              {/* <FormLabel id="metric-row-radio-buttons-group-label inline">Metric</FormLabel> */}
              <div className="flex justify-between  gap-3 items-center">
              <InputLabel>Duration</InputLabel>
                <Select
                  value={selectedNeedsMetric}
                  style={{ minWidth: 118,height: 40 }}
                  label="Duration"
                  >
                  
                  {Object.entries(dateOptions).map(([value, label]) => (
                      <MenuItem key={value} value={value} onClick={() => handleMonthsMetricChange(value)}>
                        {label}
                      </MenuItem>
                      ))}
              </Select>
            </div>
        </FormControl>
        
        </div>
        <div style={{ 
          maxHeight: "80vh", // Adjust this value based on your needs
          overflow: "scroll",
          position: "relative"
        }}>
        <table className="grid-shape-size self-center">
          <thead  className="" style={{
              position: "sticky",
              top: -1,
              zIndex: 1,
            }}>
            <tr>
              <th style={{ width: "75px" }}>Carat / Shape</th>
              {shapes.map((shape) => (
                <th onClick={() => handleShapeClick(shape)} key={shape} style={{cursor: "pointer"}}>{data[shape].trans}</th>
              ))}
            </tr>
          </thead>
          <tbody>
          
            {caratRanges.map((range, caratIndex) => (
              <tr key={range}>
                <td onClick={() => handleCaratClick(range)} style={{ width: "10%", cursor: "pointer" }}>
                  <strong>{range}</strong>
                </td>
                {shapes.map((shape, shapeIndex) => {
                  let value = gridData[shapeIndex][caratIndex][selectedMetric];
                  let colorCode = gridData
                      .flat()
                      .map((cell) => cell[selectedMetric])
                      .filter((v) => v !== undefined && v !== null)
                      .sort((a, b) => a - b);
                  if(selectedMetric === "price_change"){
                    value = Math.round(value * 10) / 10;
                    colorCode = gridData
                      .flat()
                      .map((cell) => Math.round(cell[selectedMetric] * 10)/10)
                      .filter((v) => v !== undefined && v !== null)
                      .sort((a, b) => a - b);
                  }

                  function getPercentile(arr, percentile) {
                    const index = (percentile / 100) * (arr.length - 1);
                    const lower = Math.floor(index);
                    const upper = Math.ceil(index);
                    if (lower === upper) return arr[lower];
                    return arr[lower] + (arr[upper] - arr[lower]) * (index - lower);
                  }
                  let min = getPercentile(colorCode, 10);  // 10th percentile
                  let max = getPercentile(colorCode, 90);  // 90th percentile  
                
                  {/* let min = Math.min(
                    ...gridData.flat().map((cell) => cell[selectedMetric])
                  );
                  let max = Math.max(
                    ...gridData.flat().map((cell) => cell[selectedMetric])
                  ); */}
                  let neutral = getPercentile(colorCode, 50);
                  {/* in case of turn */}
                  {/* min is 0.5 * Ideal turn and this should be red */}
                  {/* max is 2 * Ideal turn and this should be green */}
                  {/* Ideal turn should be white */}
                  {/* const idealTurn = 1.4; */}
                  let reverseColoring = false    
                  let bgColor = getBgColor(min, max, value, neutral, 50, reverseColoring);

                  if(selectedMetric === "price_change"){
                    bgColor = getPriceChangeBGColor(min, max, value, 0, 50, reverseColoring);
                  }
                  if(selectedMetric === "overhang"){
                    bgColor = getBgColor(min, max, value, neutral, 50, true);
                  }
                  let displayValue = roundIfFloat(value);
                  if(selectedMetric === "overhang"){
                    if (displayValue === null ) {
                        displayValue = "-";
                        bgColor = "#fff";
                      }
                      else{
                        displayValue = displayValue.toFixed(0);

                      }
                    }
                  if(selectedMetric === "liquidity"){
                      if (displayValue === null || displayValue === 0) {
                          displayValue = "-";
                          bgColor = "#fff";
                        }
                      else{
                        displayValue = displayValue.toFixed(0);

                      }
                  }
                  if(selectedMetric === "sales_distribution" ){
                    if (displayValue === null) {
                        displayValue = "-";
                        bgColor = "#fff";
                      }
                    else{
                      displayValue = displayValue.toFixed(2) + "%";

                    }
                  }
                  if(selectedMetric === "price_change"){
                    if (displayValue === null) {
                        displayValue = "-";
                        bgColor = "#fff";
                      }
                    else{
                      displayValue = displayValue.toFixed(1) + "%";
                      // console.log("min", min, "max", max, "value", value, "neutralValue", neutral);
                    }
                  }
                  const tooltipContent = (
                    <>
                      
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Sales Distribution: </div> 
                        <div className="text-left"><strong>{(gridData[shapeIndex][caratIndex].sales_distribution)?.toFixed(2)}</strong>%</div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Price Change: </div>
                        <div className="text-left"><strong>{(gridData[shapeIndex][caratIndex].price_change)?.toFixed(1)}</strong>%</div>
                      </div>
                      {isCsr && (
                        <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                          <div className="w-max">Count: </div>
                        <div className="text-left"><strong>{gridData[shapeIndex][caratIndex].count}</strong></div>
                      </div>
                      )}
                      
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Inventory Overhang:  </div>
                        <div className="text-left">
                          <strong>
                            {gridData[shapeIndex] &&
                            gridData[shapeIndex][caratIndex]
                              && gridData[shapeIndex][caratIndex].overhang != null
                                ? roundIfFloat(gridData[shapeIndex][caratIndex].overhang)?.toFixed(0)
                                : "-"}
                          </strong> <span className="text-xs">days</span>
                        </div>
                      </div>
                      
                      {/* <div className="flex justify-between w-max items-center" style={{width: "124px"}}>
                        <div className="w-max">Liquidity:  </div>
                        <div className="text-left"><strong>{gridData[shapeIndex][caratIndex].liquidity} </strong></div>
                      </div> */}
                    </>
                  );
                  
                  
                  return (
                    <Tooltip key={`${shape}-${range}`} title={tooltipContent} arrow placement="right-start" disableInteractive>
                      <td
                        key={shape}
                        style={getCellStyle(bgColor, shape, range)}
                        // style={{ backgroundColor: bgColor, color: "#000" }}
                        
                        onClick={(selectedCell?.shape !== shape || selectedCell?.caratRange !== range) ? () => handleCellClick(shapeIndex, caratIndex) : () => {}}

                        className={value === 0 ? (selectedMetric === "needs" ? "cursor-pointer" : "cursor-not-allowed") : "cursor-pointer"}
                      >
                        { (<span>{displayValue}</span>) }
                      </td>
                    </Tooltip>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>

      <br></br>
      <br></br>
      <hr />
      {/* Drilldown: Color-Clarity Grid */}
      {(selectedCell && queryParams.shape && queryParams.carat_range) && (
        <div className="drilldown row" >
          <div style={{ paddingTop: '24px', paddingBottom: '40px', paddingLeft: "20px", paddingRight: "20px" }}>
            <div className="pagetitle text-center  justify-center flex-col items-center">                
              {/* <h1>COLOR CLARITY DISTRIBUTION: {selectedCell.shape} / {selectedCell.caratRange}</h1> */}
              <h1 className="mb-7">COLOR CLARITY DISTRIBUTION</h1>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'center' }}>
                {/* Shape Dropdown */}
                <FormControl size="small">
                      <div className="flex justify-between gap-4 items-center" style={{ minWidth: 450 }}>
                      <InputLabel>Metric</InputLabel>
                        <Select
                          value={selectedMetric}
                          style={{ minWidth: 118 }}
                          label="Metric"
                        >
                          {Object.entries(metricOptions).map(([value, label]) => (
                            <MenuItem key={value} value={value} onClick={() => handleMetricChange(value)}>
                              {label}
                            </MenuItem>
                          ))}
                        </Select>
                        </div>
                  </FormControl>
                <div className="flex justify-center gap-4 w-max items-center">
                  <div className="flex gap-2 justify-end">
                    <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                     <InputLabel>Shape</InputLabel>
                      <Select
                        value={selectedShape || selectedCell.shape}
                        label="Shape"
                        onChange={(e) => {
                          handleShapeChange(e.target.value);
                          // You might want to reset carat range or do other logic here
                        }}
                      >
                        {shapes.map(shape => (
                          <MenuItem key={shape} value={shape}>
                            {data[shape].trans}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    
                    {/* Carat Range Dropdown */}
                    <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                      <InputLabel>Carat Range</InputLabel>
                      <Select
                        value={selectedCaratRange || selectedCell.caratRange}
                        label="Carat Range"
                        onChange={(e) => handleCaratChange(e.target.value)}
                      >
                        {caratRanges.map(range => (
                          <MenuItem key={range} value={range}>
                            {range}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    
                  </div>
                  <button 
                      className="px-4 py-2 text-blue-500 flex gap-2 ml-auto items-center self-end bg-white rounded-md border hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
                      onClick={() => handleSearchClick(shapeCaratFilter)}
                      >
                      Pricing Co-Pilot  <FiExternalLink />
                    </button>
                </div>
              </div>
            </div>
            <br></br>
            <p ref={drilldownRef}></p>
            <MIColorClarityGrid
              // colorClarityData={colorClarityData}
              idealTurn={idealTurn}
              isResetting={isResetting}
              accountDetails={accountDetails}
              isCsr={isCsr}
              selectedShape={selectedShape}
              setSelectedShape={setSelectedShape}
              selectedCaratRange={selectedCaratRange}
              setSelectedCaratRange={setSelectedCaratRange}
              // setQueryParams={setQueryParams}
              handleShapeChange={handleShapeChange}
              handleCaratChange={handleCaratChange}
              queryParams={queryParams}
              shape={selectedCell.shape}
              caratRange={selectedCell.caratRange}
              selectedMetric={selectedMetric}
              selectedNeedsMetric={selectedNeedsMetric}
              selectedLocation={selectedLocation}
              highlightedGroup={hoveredGroup} // Pass hovered group to detailed view
              setHoveredGroup={setHoveredGroup} // Pass hovered group to detailed view
              gridData={gridData}
              data={data}
              shapes={shapes}
              caratRanges={caratRanges}
              onCellClick={(color, clarity) =>
                console.log("Color:", color, "Clarity:", clarity)
              }
            />
          </div>
          
        </div>
      )}
    </div>
  );
};


export default MIShapeCaratGrid;
